/**
 * @generated SignedSource<<93328deb1ea19e13282a1ed7e2f9f69a>>
 * @relayHash 202022d50b866807665f58f8d619815f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e460dc871a9077aa975392ac04d7f14eb892b9bfb57a3617c8827bf04c82e898

import type { ConcreteRequest } from 'relay-runtime';
export type useVersionHistoryAgenticQuery$variables = {
  after?: string | null;
  contentId: string;
};
export type useVersionHistoryAgenticQuery$data = {
  readonly contentHistory: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly collaborators: {
        readonly collaborators: ReadonlyArray<{
          readonly agent: {
            readonly accountId: string;
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          } | null;
          readonly person: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          };
        } | null> | null;
      } | null;
      readonly editedBy: {
        readonly agent: {
          readonly accountId: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
        readonly person: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
      } | null;
      readonly friendlyWhen: string;
      readonly message: string;
      readonly number: number;
      readonly when: string;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
};
export type useVersionHistoryAgenticQuery = {
  response: useVersionHistoryAgenticQuery$data;
  variables: useVersionHistoryAgenticQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "KnownUser"
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnknownUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v9 = {
  "concreteType": "ConfluenceAgent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ]
},
v10 = [
  {
    "kind": "LinkedField",
    "name": "person",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ]
  },
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "number"
},
v12 = {
  "kind": "ScalarField",
  "name": "when"
},
v13 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v14 = {
  "kind": "ScalarField",
  "name": "message"
},
v15 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "count"
},
v17 = [
  {
    "kind": "LinkedField",
    "name": "person",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ]
  },
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useVersionHistoryAgenticQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentHistoryList",
        "kind": "LinkedField",
        "name": "contentHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentHistory",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConfluenceCollaborator",
                "kind": "LinkedField",
                "name": "editedBy",
                "plural": false,
                "selections": (v10/*: any*/)
              },
              {
                "concreteType": "ContributorUsers",
                "kind": "LinkedField",
                "name": "collaborators",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceCollaborator",
                    "kind": "LinkedField",
                    "name": "collaborators",
                    "plural": true,
                    "selections": (v10/*: any*/)
                  }
                ]
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useVersionHistoryAgenticQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentHistoryList",
        "kind": "LinkedField",
        "name": "contentHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentHistory",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConfluenceCollaborator",
                "kind": "LinkedField",
                "name": "editedBy",
                "plural": false,
                "selections": (v17/*: any*/)
              },
              {
                "concreteType": "ContributorUsers",
                "kind": "LinkedField",
                "name": "collaborators",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceCollaborator",
                    "kind": "LinkedField",
                    "name": "collaborators",
                    "plural": true,
                    "selections": (v17/*: any*/)
                  }
                ]
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "202022d50b866807665f58f8d619815f",
    "id": "e460dc871a9077aa975392ac04d7f14eb892b9bfb57a3617c8827bf04c82e898",
    "metadata": {},
    "name": "useVersionHistoryAgenticQuery",
    "operationKind": "query",
    "text": "query useVersionHistoryAgenticQuery($contentId:ID!,$after:String){contentHistory(contentId:$contentId,after:$after){nodes{editedBy{person{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName,profilePicture{path}},agent{accountId,displayName,profilePicture{path}}},collaborators{collaborators{person{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName,profilePicture{path}},agent{accountId,displayName,profilePicture{path}}}},number,when,friendlyWhen,message},pageInfo{hasNextPage,endCursor},count}}"
  }
};
})();

(node as any).hash = "2036e77793473833e20f6966f52ee5aa";

export default node;
